import type { InputProps as AntInputProps, InputRef } from "antd";
import { Input as AntInput } from "antd";
import { forwardRef, ForwardRefExoticComponent, RefAttributes } from "react";
import { TextArea } from "./textarea";
import { useDataEntryRestriction } from "@/shared/security/model/data-entry-restriction";

export type InputProps = AntInputProps;

const InputComponent: ForwardRefExoticComponent<
  InputProps & RefAttributes<InputRef>
  // eslint-disable-next-line react/prop-types
> = forwardRef(function Input({ disabled, ...rest }, ref) {
  const abilities = useDataEntryRestriction();

  return (
    <AntInput ref={ref} disabled={!abilities.canModify || disabled} {...rest} />
  );
});

export const Input = Object.assign(InputComponent, {
  TextArea,
  Password: AntInput.Password,
  Search: AntInput.Search,
});
